var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upload-img-c",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("img", {
        staticClass: "triangle",
        attrs: { src: require("../../images/top-v.png") },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("img", { attrs: { src: _vm.uploadedImg } }),
        _vm._v(" "),
        _c("div", {
          staticClass: "close-icon",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              _vm.handleClose($event)
            },
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }